import { apiPostAuth, apiPutAuth, apiGetAuth } from '@/utils/api'
import { API_COMPANY_SUBDIVISION, API_CORE } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  company_subdivision_list: { 
    isLoading: false, 
    data: [] 
  },
  detail_company_subdivision: {
    isLoading: false, 
    data: {}
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_COMPANY_SUBDIVISION_LIST": (state, payload) => {
    state.company_subdivision_list = payload
  },
  "SET_DETAIL_COMPANY_SUBDIVISION": (state, payload) => {
    state.detail_company_subdivision = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getCompanySubdivisionList(context, payload) {
    try {
      context.commit('SET_COMPANY_SUBDIVISION_LIST', { isLoading: true })
      const response = await apiGetAuth(API_COMPANY_SUBDIVISION.LIST, payload)
      context.commit('SET_COMPANY_SUBDIVISION_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_COMPANY_SUBDIVISION_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailCompanySubdivision(context, payload) {
    context.commit('SET_DETAIL_COMPANY_SUBDIVISION', { isLoading: true })
    try {
      const response = await apiGetAuth(API_COMPANY_SUBDIVISION.BY_ID(payload))
      context.commit('SET_DETAIL_COMPANY_SUBDIVISION', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_COMPANY_SUBDIVISION', {
        isLoading: false,
        data: {}
      })
      notificationDanger(error)
    }
  },
  async createCompanySubdivision (context, payload) {
    try {
      const response = await apiPostAuth(API_COMPANY_SUBDIVISION.CREATE_COMPANY_SUBDIVISION, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async syncCompanySubdivision (context, id) {
    const response = await apiPostAuth(API_CORE.SYNC_SUBDIVISION(id), null, 180000)
    return response.data
  },
  async updateCompanySubdivision (context, payload) {
    try {
      const response = await apiPutAuth(API_COMPANY_SUBDIVISION.BY_ID(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_company_subdivision_list: state => {
    return state.company_subdivision_list
  },
  get_detail_company_subdivision: state => {
    return state.detail_company_subdivision
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
